// @flow strict

import * as React from 'react';

import styles from './ImagePreloader.css';

type Props = {|
  urls: string[],
|};

/**
 * Creates a hidden div with images specified by the urls passed in the props
 */
const ImagePreloader = ({ urls }: Props) => (
  <div className={styles.preloader}>
    {urls.map(url => (
      <img key={url} src={url} />
    ))}
  </div>
);

export default ImagePreloader;
